import axios from "axios";

type Step = {
  heading: string;
  description: string;
};

type ThreeStepsResponse = {
  message: Step[];
  status: string;
};

export const get3StepsQuotes = async (
  companyName: string,
  companyType: string
): Promise<Step[]> => {
  try {
    const params = { company_name: companyName, company_type: companyType };
    const response = await axios.get<ThreeStepsResponse>(
      `${process.env.REACT_APP_SERVER_URL}/api/landing-pages/generate-three-steps`,
      { params }
    );
    return response.data?.message;
  } catch (error) {
    console.error("Error fetching 3 steps quotes: ", error);
    return [];
  }
};

export const extractThreeStepTitleAndSubtitle = (
  threeStepResponse: Step[]
): Record<string, string>[] => {
  console.log("threeStepResponse", threeStepResponse);
  const completeResponse = threeStepResponse.map((item, index) => {
    index = index + 1;
    return {
      [`three_step_${index}_header`]: item?.heading || "",
      [`three_step_${index}_subtitle`]: item?.description || "",
    };
  });
  return completeResponse;
};
